export const buildErrorMessage = async (
  response: Response
): Promise<string> => {
  const errorMessage = `Request ${response.url} failed. Status Code: ${
    response.status
  }, Status Text: ${response.statusText}, Details: ${await response.text()}`;
  return errorMessage;
};
